export const images = {
  trackingPageEditor: 'https://media.synctrack.io/megamind-ordertracking/asset/trackingpageeditor.png',
  prePurchaseEDD: 'https://media.synctrack.io/megamind-ordertracking/asset/trackingpage_preedd.png',
  postPurchaseEDD: 'https://media.synctrack.io/megamind-ordertracking/asset/trackingpage_postedd.png',
  blacklisting: 'https://media.synctrack.io/megamind-ordertracking/asset/trackingpage_blacklist.png',
};
